import React from 'react';
import { CheckboxGroup } from 'ui';

/**
 * OptionalCheckboxGroup - Wraps a list of options in the v2 CheckboxGroup ONLY when the
 * consumer opts in by providing a group name (`legend`) — which selection lists do. Without
 * a `legend` it renders a plain `<div>`, so non-selection consumers stay semantically correct
 * (a `<fieldset>`/`<legend>` should only group actual form controls).
 *
 * Shared by the list components (UserList, UnitList, ExerciseLibraryList, ClassroomToAddList,
 * GoogleClassroomStudentsList) so the opt-in grouping rule lives in a single place.
 */

interface OptionalCheckboxGroupProps {
  children: React.ReactNode;
  className: string;
  isLegendHidden?: boolean;
  legend?: string;
}

function OptionalCheckboxGroup({ children, className, isLegendHidden = false, legend }: OptionalCheckboxGroupProps): JSX.Element {
  if (legend) {
    return (
      <CheckboxGroup className={className} isLegendHidden={isLegendHidden} legend={legend}>
        {children}
      </CheckboxGroup>
    );
  }

  return <div className={className}>{children}</div>;
}

export default OptionalCheckboxGroup;
